"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
var _log = require("@/utils/log");
var _resource = require("@/api/resource");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultValue = [];
var _default = exports.default = {
  name: 'TrainingResource',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    parentResource: {
      type: Array,
      default: defaultValue
    },
    trainingId: {
      type: String,
      default: ''
    },
    fromId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dragging: false,
      fullscreenloading: false,
      resourceLibrary: [],
      resources: [],
      resourcesWithTitle: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        sort: '+title',
        q: undefined,
        category: 'event-resource'
      }
    };
  },
  computed: {
    filterResLibrary: function filterResLibrary() {
      var _this = this;
      return this.resourceLibrary.filter(function (v) {
        if (_this.isNotInTraining(v)) {
          return v;
        }
        return false;
      });
    }
  },
  watch: {
    /*
    resources: {
      handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal)
      },
      deep: true
    },
    */
    resourcesWithTitle: {
      handler: function handler(newVal) {
        // showDebugLog('Fired Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal);
      },
      deep: true
    }
  },
  created: function created() {
    this.getResourceLibrary();
    if (this.trainingId === 'copy') {
      if (this.$route.query.r === 'true') {
        this.getSelectedResource(this.fromId);
      }
    } else {
      this.getSelectedResource(this.trainingId);
    }
    this.resources = this.parentResource;
  },
  mounted: function mounted() {},
  methods: {
    getResourceLibrary: function getResourceLibrary(newSearch) {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      if (newSearch) {
        this.query.page = 1;
      }
      (0, _resource.fetchList)(token, this.query).then(function (response) {
        (0, _log.showDebugLog)('getResourceLibrary-API', response.data);
        _this2.resourceLibrary = response.data.rows;
        _this2.total = response.data.count;
      }).catch(function (error) {
        (0, _log.showDebugLog)('getResourceLibrary-API-error', error.repsonse.data.message);
        (0, _log.displayPopupMessage)(error, 'error');
        // const msg = (typeof error.response === 'undefined') ? error : error.response.data.message
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: msg })
      });
    },
    getSelectedResource: function getSelectedResource(id) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _resource.getResourceByTraining)(token, id).then(function (response) {
        (0, _log.showDebugLog)('getResourceLibrary-API', response.data);
        _this3.resourcesWithTitle = response.data.rows;
      }).catch(function (error) {
        (0, _log.showDebugLog)('getResourceLibrary-API-error', error.repsonse.data.message);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    passBackToParent: function passBackToParent(res) {
      var resList = [];
      for (var i = 0; i < this.resourcesWithTitle.length; ++i) {
        resList.push(this.resourcesWithTitle[i].id);
      }
      this.$emit('updateParentResource', resList);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getResourceLibrary(false);
    },
    changeResourceSelection: function changeResourceSelection(value, id, title) {
      if (value) {
        this.resourcesWithTitle.push({
          id: id,
          title: title
        });
      } else {
        /*
        const removedItem = _.remove(this.resourcesWithTitle, (item) => {
         return item.id === id
        })
        */
        this.resourcesWithTitle = this.resourcesWithTitle.filter(function (item) {
          return item.id !== id;
        });
      }
    },
    getResourceTitle: function getResourceTitle(id) {
      return '123';
    }
  }
};